// ============================================================
// Design tokens Siverix — partagés admin/desktop/mobile
// Cf. docs/08_design_system.md
// ============================================================
export const darkColors = {
    bg: '#0e0f12',
    surface: '#15171c',
    surfaceHover: '#1d2027',
    text: '#e6edf3',
    textMuted: '#7d8590',
    border: '#2a2e36',
    accent: '#7c5cff',
    accentHover: '#9077ff',
    success: '#3fb950',
    warn: '#d29922',
    error: '#f85149',
};
export const lightColors = {
    bg: '#ffffff',
    surface: '#f6f8fa',
    surfaceHover: '#eef0f3',
    text: '#1f2328',
    textMuted: '#656d76',
    border: '#d0d7de',
    accent: '#5d3ed8',
    accentHover: '#7c5cff',
    success: '#1a7f37',
    warn: '#9a6700',
    error: '#cf222e',
};
export const themes = {
    dark: darkColors,
    light: lightColors,
};
export const DEFAULT_THEME = 'dark';
// Spacing scale (4px base)
export const spacing = {
    '0': '0',
    '1': '4px',
    '2': '8px',
    '3': '12px',
    '4': '16px',
    '5': '20px',
    '6': '24px',
    '8': '32px',
    '10': '40px',
    '12': '48px',
    '16': '64px',
    '20': '80px',
    '24': '96px',
};
// Border radius
export const radius = {
    none: '0',
    sm: '4px',
    base: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
};
// Typography
export const fonts = {
    sans: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    mono: '"JetBrains Mono", "SF Mono", Consolas, "Liberation Mono", monospace',
};
export const fontSizes = {
    xs: '11px',
    sm: '12px',
    base: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '36px',
};
export const fontWeights = {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
